import { onCollabSpaceUpdated } from 'owa-calendar-compose-form-actions';
import { getViewStateById } from '../selectors/collabSpaceSelectors';
import type { CollabSpaceExtendedProperty } from '../store/schema';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isSeriesMaster } from 'owa-calendar-event-capabilities';
import { parseCollabSpace } from './parseCollabSpace';

const MEETING_AGENDA_TYPE = 'collaborativeSpace';

export default function updateCalendarEventCollabSpace(event: CalendarEvent, viewStateId: string) {
    const viewState = getViewStateById(viewStateId);

    let isShared = viewState?.isShared;
    let shareLink = viewState?.shareLink;
    let collabAllowed = viewState?.collabAllowed;

    if (!shareLink || shareLink.length === 0) {
        const parsedCollabSpace = parseCollabSpace(event.CollabSpace);
        shareLink = parsedCollabSpace.shareLink;
        isShared = parsedCollabSpace.isShared;
        collabAllowed = collabAllowed ?? parsedCollabSpace.collabAllowed;
    }

    if (!isShared || isShared === 'false') {
        const isSeriesMasterDraft = event.Recurrence?.RecurrencePattern;
        isShared = isSeriesMasterDraft || isSeriesMaster(event) ? 'true' : 'false';
    }

    const collabSpace = {
        ...(shareLink?.length > 0 &&
            ({
                type: MEETING_AGENDA_TYPE,
                location: shareLink,
                metadata: {
                    state: collabAllowed ? 'Enabled' : 'Disabled',
                    isShared: isShared,
                },
            } as CollabSpaceExtendedProperty)),
    };

    if (Object.keys(collabSpace).length > 0) {
        onCollabSpaceUpdated(JSON.stringify(collabSpace));
    }
}
